import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  ElementRef,
  ViewContainerRef,
  QueryList,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsModalService } from "ngx-bootstrap/modal";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { FormUtil } from "../../../utils/formutils";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DashboardService } from "../../dashboard.service";
import { AccountantService } from "../accountant/accountant.service";
import { ManageResourcesModalComponent } from "../accountant/modals/manage-resources-modal.component";
import { Subscription } from "rxjs";
import { DragulaService } from "ng2-dragula";
import * as _ from "underscore";
import { ResourceSearchPipe } from "../common/resources.pipes";
import { ResourcesItemComponent } from "../common/resources-item.component";
import { NgIf, NgFor } from "@angular/common";
import { PaidOverlayDirective } from "../../paid-overlay.directive";

/**
 * Resources widget
 */
@Component({
    selector: "app-resources-panel-widget",
    templateUrl: "./resources-panel.component.html",
    styleUrls: ["../common/resources.component.css"],
    imports: [
        PaidOverlayDirective,
        NgIf,
        NgFor,
        ResourcesItemComponent,
        ResourceSearchPipe,
    ]
})
export class ResourcesPanelWidgetComponent implements OnInit {
  @ViewChild("resourceInput") resourceInput: ElementRef;
  @Input() preview = false;
  @Input() isForDefault = false;
  _company: any;

  @Input()
  set company(value: any) {
    if (value !== undefined) {
      this._company = value;
      // Update client and apps variables
      this.current_client = this._company;
      this.company_resources = this._company.resources;

      // Calculate the differences between the full list and the client list
      // so it only shows in the complete list the apps that user doesnt have
      this.global_resources = _.filter(
        this.fixed_global_resources,
        (obj: any) => {
          return !_.findWhere(this.company_resources, { id: obj.id });
        }
      );

      this.practice_resources = _.filter(
        this.fixed_practice_resources,
        (obj: any) => {
          return !_.findWhere(this.company_resources, { id: obj.id });
        }
      );
    }
  }

  @Input()
  set resources(value: any) {
    this.current_client.resources = value;
    this.company_resources = this._company.resources;

    // Calculate the differences between the full list and the client list
    // so it only shows in the complete list the apps that user doesnt have
    this.global_resources = _.filter(
      this.fixed_global_resources,
      (obj: any) => {
        return !_.findWhere(this.company_resources, { id: obj.id });
      }
    );

    this.practice_resources = _.filter(
      this.fixed_practice_resources,
      (obj: any) => {
        return !_.findWhere(this.company_resources, { id: obj.id });
      }
    );
  }

  bsModalRef: BsModalRef;
  public modalRef: BsModalRef;
  addResourceForm: UntypedFormGroup;
  formUtil: FormUtil;
  fileForm: FormData = new FormData();
  user: any;
  data: any;

  // Store global resources from /resource when ACCOUNTANT
  global_resources: any = [];

  // Store company specific resources from /resource when ACCOUNTANT
  practice_resources: any = [];

  // Store company specific resources from /resource when CLIENT
  company_resources: any = [];

  // Fixed copy for sorting purposes
  fixed_global_resources: any = [];

  fixed_practice_resources: any = [];

  innerWidth: any;
  current_client: any;
  showAddResource: any;

  search = "";
  clientSubscription: Subscription;
  sort_type = "Order";
  dragulaOptions: any = {
    direction: "horizontal",
  };

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
  };

  constructor(
    private localStorage: LocalStorageService,
    private modalService: BsModalService,
    private formBuilder: UntypedFormBuilder,
    private dashboardService: DashboardService,
    private accountantService: AccountantService,
    vcr: ViewContainerRef
  ) {
    this.addResourceForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      description: [null, []],
      file: [null, []],
      category: [null, []],
      file_type: [null, [Validators.required]],
      url: [null, []],
    });
  }

  ngOnInit(): void {
    this.showAddResource = false;

    this.innerWidth = window.screen.width;

    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    // this.company = this.localStorage.get("company");

    if (this.innerWidth < 600) {
      this.slideConfig = {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
      };
    }

    // Retrieve the resources for ACCOUNTANT or CLIENT
    this.dashboardService.get_resources().then((res: any) => {
      const response = res;
      this.global_resources = response.global_resources;
      this.practice_resources = response.practice_resources;

      this.fixed_global_resources = response.global_resources;
      this.fixed_practice_resources = response.practice_resources;
    });
  }

  public openModal(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.show(ManageResourcesModalComponent, {
      class: "modal-lg",
    });

    this.bsModalRef.content.isForDefault = this.isForDefault;

    this.bsModalRef.content.ngOnChanges({
      global_resources: this.global_resources,
      practice_resources: this.practice_resources,
      fixed_global_resources: this.fixed_global_resources,
      fixed_practice_resources: this.fixed_practice_resources,
      company_id: this._company.id,
      current_client: this.current_client,
      company_resources: this.company_resources,
    });
  }

  sort(type): void {
    this.sort_type = type.charAt(0).toUpperCase() + type.slice(1);
    if (type === "title") {
      this.company_resources = _.sortBy(this.company_resources, "name");
    } else if (type === "type") {
      this.company_resources = _.sortBy(this.company_resources, "file_type");
    } else {
      this.company_resources = _.sortBy(this.company_resources, "order");
    }
  }

  trackById(index, resource) {
    return resource.id;
  }
}
